// Version constants for tracking user agreements and app versions

// Terms and Conditions Version
// Update this when T&C are modified to track which version users agreed to
export const TERMS_VERSION = '0';

// Add other version constants here as needed (e.g., CLIENT_VERSION, API_VERSION)